/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { FormulaCalculationDto, FormulaRestService } from '@gh/builder-shared-data';
import { NumberType } from '@gh/core-type';
import { map$ } from '@gh/rx/operators';
import { omit } from 'lodash';
import { Observable } from 'rxjs';

export type FormulaCalculation = FormulaCalculationDto & { isApproximated: boolean };

const formulaCalculationToDto = (calculation: FormulaCalculation) =>
  <FormulaCalculationDto>omit(calculation, 'isApproximated');

@Injectable()
export class FormulaCalculationService {
  constructor(private formulaRest: FormulaRestService) {

  }

  calculate(request: FormulaCalculation, type: NumberType): Observable<string> {
    return this.formulaRest.calculate(formulaCalculationToDto(request)).pipe(
      map$(({ value }) => value),
      map$((value) => type.format(value)),
      map$((str) => request.isApproximated ? `~${str}` : str));
  }
}
